import { render, staticRenderFns } from "./music.vue?vue&type=template&id=069beae0&scoped=true"
import script from "./music.vue?vue&type=script&lang=js"
export * from "./music.vue?vue&type=script&lang=js"
import style0 from "./music.vue?vue&type=style&index=0&id=069beae0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069beae0",
  null
  
)

export default component.exports